import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from '@chakra-ui/react';
import { type FC, useRef } from 'react';

import { Button, ButtonGroup } from '@revelio/ui';

import modalStyles from '../Modal/themedModal.module.css';

interface ClearPageDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ClearPageDialog: FC<ClearPageDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const cancelRef = useRef(null);
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent className={modalStyles.content}>
          <AlertDialogHeader>Clear all charts?</AlertDialogHeader>
          <AlertDialogBody>
            This will remove all charts from the current page. This action
            cannot be undone.
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup>
              <Button
                ref={cancelRef}
                variant="ghost"
                color="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button color="destructive" onClick={onConfirm}>
                Clear Page
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
